// View switcher for Active / No answer / Voicemail / Unknown caller.
import type { ReactNode } from 'react';
import { Icon } from '../../_shared/IconSprite.js';
import type { ConversationView } from '../mockData.js';
import { CONVERSATION_LABELS } from '../mockData.js';

export interface ConversationViewsProps {
  value: ConversationView;
  onChange: (view: ConversationView) => void;
  onOpenHistory: () => void;
}

const ICONS: Record<ConversationView, string> = {
  active: 'help',
  noanswer: 'clock',
  voicemail: 'message',
  unknown: 'people',
};

export function ConversationViews({
  value,
  onChange,
  onOpenHistory,
}: ConversationViewsProps): ReactNode {
  const keys: ConversationView[] = ['active', 'noanswer', 'voicemail', 'unknown'];
  return (
    <div className="cc-view-tabs" role="group" aria-label="Conversation examples">
      {keys.map(k => (
        <button
          key={k}
          type="button"
          data-conversation={k}
          aria-pressed={value === k}
          onClick={() => onChange(k)}
        >
          <Icon id={ICONS[k]} />
          {CONVERSATION_LABELS[k]}
        </button>
      ))}
      <button className="cc-history-link" id="cc-history" type="button" onClick={onOpenHistory}>
        Conversation history
        <Icon id="arrow" />
      </button>
    </div>
  );
}
